import React from "react";
import { Form as BootstrapForm } from 'react-bootstrap';
import { TechnologyListItem } from "../../../../../common/types/tool.types";

interface TechnologiesListProps {
  technologiesList: TechnologyListItem[];
  isNewTool: boolean;
  selectedTechnologiesCount: number;
  setFieldValue: (field: string, value: any) => void;
  values: {
    technologiesList: TechnologyListItem[];
  };
  isView?: boolean;
}

const TechnologiesList: React.FC<TechnologiesListProps> = ({
  technologiesList,
  isNewTool,
  selectedTechnologiesCount,
  setFieldValue,
  values,
  isView = false,
}) => {
  if (!technologiesList?.length) {
    return null;
  }

  return (
    <div className="d-flex flex-column align-items-start">
      {technologiesList.map((technology) => {
        const isCurrentlySelected = technology?.selected;
        const canToggle = !isNewTool || isCurrentlySelected || selectedTechnologiesCount === 0;
        const isDisabled = isView || !canToggle;
        
        return (
          <div key={technology.value} className="technology-item d-flex align-items-center gap-16">
            <BootstrapForm.Group className="fixed-checkbox blue-checkbox pointer-checkbox" style={{ height: 'auto' }}>
              <BootstrapForm.Check 
                type="checkbox"
                onChange={e => {
                  e.stopPropagation();
                  if (!canToggle || isView) return;
                  setFieldValue('technologiesList', values.technologiesList.map((t) => t.value === technology.value ? { ...t, selected: !t.selected } : t));
                }}
                checked={technology?.selected}
                disabled={isDisabled}
                id={`cb-${technology.value}`}
                className="checkbox"
              />
            </BootstrapForm.Group>
            <label htmlFor={`cb-${technology.value}`} className="m-0 f-14 line-height-22 f-400 f-black">
              {technology.label}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default TechnologiesList;

